type ProcessStepHeadingProps = {
  number: string
  title: string
  as?: 'h2' | 'h3'
  className?: string
}

/**
 * Numbered step heading. Design-system styles (Figma):
 *   number → text-title/7xl-hug (72px at desktop), title → text-title/xl-hug (20px at desktop).
 * Both are "hug" styles (trimmed to cap height), so the box is exactly the number's cap height —
 * 52px at desktop, matching the 374×52 heading in the design. Smaller breakpoints step down through
 * the same scale (4xl → 5xl → 6xl → 7xl); each box height is 0.72 × the number's font size.
 */
export function ProcessStepHeading({
  number,
  title,
  as: Tag = 'h3',
  className = '',
}: ProcessStepHeadingProps) {
  return (
    <div
      className={`relative flex h-[26px] items-center sm:h-[35px] md:h-[43px] lg:h-[52px] ${className}`.trim()}
    >
      {/* flow-root contains the hug style's fallback negative margins so they cannot shift the number. */}
      <div aria-hidden className="pointer-events-none absolute left-0 top-0 z-0 flow-root select-none">
        <p className="ds-text-title-4xl-hug text-blue-bell-200 sm:ds-text-title-5xl-hug md:ds-text-title-6xl-hug lg:ds-text-title-7xl-hug">
          {number}
        </p>
      </div>
      <Tag className="ds-text-title-lg-hug relative z-10 text-gray-900 sm:ds-text-title-xl-hug">
        {title}
      </Tag>
    </div>
  )
}
